import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Compass, Building2, Wallet } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PROGRAMS } from "@/lib/constants";

const icons = [BookOpen, Compass, Building2, Wallet];

export const ProgramsPreview = () => (
  <section id="programs" data-testid="programs-section" className="scroll-mt-24 bg-[#0E0E12] py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="programs-label">
          Programs
        </p>
        <h2
          data-testid="programs-heading"
          className="mt-3 max-w-2xl font-heading text-2xl font-bold tracking-tight text-[#F2EEE3] sm:text-3xl lg:text-4xl"
        >
          Education Designed Around Your Goals.
        </h2>
      </Reveal>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {PROGRAMS.map((program, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={program.slug} delay={i * 0.08}>
              <div
                data-testid={`program-card-${program.slug}`}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#17171C] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#C9A227]/30 hover:shadow-xl hover:shadow-black/40"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#141419] transition-colors duration-300 group-hover:bg-[#C9A227]/10">
                  <Icon className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
                </span>
                <h3 className="mt-6 font-heading text-lg font-semibold tracking-tight text-[#F2EEE3]">
                  {program.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#B8B2A6]">{program.description}</p>
                <Link
                  to={`/programs#${program.slug}`}
                  data-testid={`program-learn-more-${program.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#D8B54A] transition-colors duration-200 hover:text-[#E4C463]"
                >
                  Learn More
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.2}>
        <p
          data-testid="programs-disclaimer"
          className="mt-8 rounded-xl border border-white/10 bg-[#141419] px-6 py-4 text-[13px] leading-relaxed text-[#B8B2A6]"
        >
          J11 Consulting provides education and mentorship. Results vary by individual. We do not
          guarantee credit score changes, approvals, funding amounts, interest rates or any specific
          financial outcome.
        </p>
      </Reveal>
    </div>
  </section>
);
